import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import { url, sitename } from '../../../config';

class BookingConfirmationGuest extends Component {
  static propTypes = {
    content: PropTypes.shape({
      hostName: PropTypes.string.isRequired,
      guestName: PropTypes.string.isRequired,
      listTitle: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
    }).isRequired,
  };

  render() {
    const textContainerStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      padding: '35px',
    };
    const textStyle = {
      color: '#484848',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
    };

    const linkText = {
      color: '#35BAEF',
      fontSize: '16px',
      textDecoration: 'none',
      cursor: 'pointer',
    };

    const {
      content: { guestName, hostName, listTitle, threadId },
    } = this.props;
    let contactURL = url + '/inbox/' + threadId;

    return (
      <Layout>
        <Header color="#159CE9" backgroundColor="#F7F7F7" />
        <div>
          <Table width="100%">
            <TBody>
              <TR>
                <TD style={textContainerStyle}>
                  <EmptySpace height={20} />
                  <div style={textStyle}>Hi {guestName},</div>
                  <EmptySpace height={20} />
                  <div style={textStyle}>
                    Get ready - you're renting {listTitle}
                  </div>
                  <EmptySpace height={20} />
                  <div style={textStyle}>
                    {hostName} has approved your request to rent their{' '}
                    {listTitle}. Please review details of your reservation and{' '}
                    <a style={linkText} href={contactURL}>
                      contact host
                    </a>{' '}
                    to coordinate pickup.
                  </div>
                  <EmptySpace height={20} />
                  <div style={textStyle}>
                    Thanks, <br />
                    The {sitename} Team
                  </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }
}

export default BookingConfirmationGuest;



// WEBPACK FOOTER //
// ./src/core/email/template/BookingConfirmationGuest.js